import { Component, OnInit } from '@angular/core';
import { DynamicLoaderService } from '../services/dynamic-loader.service';

@Component({
  selector: 'app-not-found-page',
  templateUrl: './not-found-page.component.html',
  styleUrls: ['./not-found-page.component.scss']
})
export class NotFoundPageComponent implements OnInit {

  constructor(
    private readonly dynamicLoaderService: DynamicLoaderService
  ) { }

  ngOnInit(): void {
    this.dynamicLoaderService.loadCSS('/assets/css/dashforge.auth.css');
  }

}
